import { Breakpoints } from '@/hooks/useBreakpoint';
import styled from 'styled-components';

export const Container = styled.div<{ $breakpoint: Breakpoints }>`
  display: flex;
  flex-direction: column;
  flex: 1;
  max-width: 1280px;
  padding: ${({ theme }) => theme.spacing[5]}px 0;
  gap: ${({ theme }) => theme.spacing[5]}px;
`;

export const Label = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  padding: 0 ${({ theme }) => theme.spacing[5]}px;
  gap: ${({ theme }) => theme.spacing[2]}px;
`;
